import {BaseCaller} from './api';

export default class ComanyApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    public list(): Promise<any> {
        return this.caller.get('company/');
    };


    add(data: { name: string, photo: string, adminId: number; }) {
        return this.caller.post('company/', data);
    }

    update(id: number, data: any) {
        return this.caller.put(`company/${id}`, data);
    }

    byId(id: number) {
        return this.caller.get(`company/${id}`);
    }
    importLocation(data: { companyId: number, obs:string,zonas: any[]}) {
        return this.caller.post(`company/importLocation/}`, data);
    }

    delete(id: number) {
        return this.caller.delete(`company/${id}`);
    }
}


// WEBPACK FOOTER //
// ./src/api/company-api.ts